var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82255 15.3556C4.86719 15.3556 4.91183 15.3511 4.95647 15.3444L8.71094 14.686C8.75558 14.677 8.79799 14.6569 8.82924 14.6235L18.2913 5.1614C18.312 5.14075 18.3284 5.11622 18.3396 5.08922C18.3508 5.06222 18.3566 5.03327 18.3566 5.00404C18.3566 4.9748 18.3508 4.94586 18.3396 4.91885C18.3284 4.89185 18.312 4.86732 18.2913 4.84667L14.5815 1.13462C14.5391 1.09221 14.4833 1.06989 14.423 1.06989C14.3627 1.06989 14.3069 1.09221 14.2645 1.13462L4.80246 10.5967C4.76897 10.6302 4.74888 10.6703 4.73996 10.715L4.08147 14.4694C4.05976 14.589 4.06752 14.7121 4.10408 14.828C4.14064 14.9439 4.2049 15.0491 4.29129 15.1346C4.43862 15.2775 4.62388 15.3556 4.82255 15.3556ZM6.32701 11.4627L14.423 3.36899L16.0592 5.00515L7.96317 13.0989L5.97879 13.4493L6.32701 11.4627ZM18.7132 17.2306H2.2846C1.88951 17.2306 1.57031 17.5498 1.57031 17.9449V18.7485C1.57031 18.8467 1.65067 18.927 1.74888 18.927H19.2489C19.3471 18.927 19.4275 18.8467 19.4275 18.7485V17.9449C19.4275 17.5498 19.1083 17.2306 18.7132 17.2306Z",
    fill: "#1890FF",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.361a24f84892f44384a2aa7c7792028a.svg";
export { ForwardRef as ReactComponent };